/* Product row (sections/nividas-product-row.liquid), 2026-10-15.

   Tabs: role=tablist, arrow keys / Home / End move between tabs, switching
   only toggles `hidden` (all panels are rendered server-side).

   Row behaviour mirrors sections/featured-collection.liquid exactly: a
   static row when the cards fit (desktop with 4 or fewer), otherwise the
   same Flickity wrap-around carousel (the mobile swipe). A hidden panel has
   no width, so its carousel is started the first time it is shown, never
   while hidden. */
(function () {
  'use strict';

  var BREAKPOINT = 768;

  function getFlickity() {
    if (typeof window.Flickity === 'function') return window.Flickity;
    return null;
  }
  function isMobile() {
    return window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').matches;
  }

  function startPanel(panel, tries) {
    if (!panel || panel.hasAttribute('hidden') || panel.getAttribute('data-nv-row-ready') === '1') return;
    var wrapper = panel.querySelector('.grid-overflow-wrapper');
    var grid = wrapper && wrapper.querySelector('.grid');
    if (!grid) return;
    var items = grid.querySelectorAll('.grid__item.grid-product');
    var perRow = parseInt(wrapper.style.getPropertyValue('--nv-carousel-per-row'), 10) || 4;
    // Find your frame (sections/nividas-help-block.liquid): each card opens
    // on the size that fits the band, given as "productId:variantId,…"
    var vmap = panel.getAttribute('data-nv-variants');
    if (vmap) {
      var pairs = vmap.split(',');
      for (var v = 0; v < pairs.length; v++) {
        var kv = pairs[v].split(':');
        if (kv.length !== 2) continue;
        var card = grid.querySelector('.grid__item.grid-product[data-product-id="' + kv[0] + '"]');
        if (!card) continue;
        var handle = card.getAttribute('data-product-handle');
        var links = card.querySelectorAll('a[href]');
        for (var k = 0; k < links.length; k++) {
          try {
            var u = new URL(links[k].href, window.location.origin);
            if (!handle || !/\/products\//.test(u.pathname) || u.pathname.split('/products/')[1] !== handle) continue;
            u.searchParams.set('variant', kv[1]);
            links[k].href = u.pathname + u.search + u.hash;
          } catch (e) {}
        }
      }
    }
    // Reveal the cards now: their scroll-in animation was measured while the
    // panel was hidden. Only the card containers lose it — the images keep
    // their own fade, and are loaded eagerly (a row holds a handful), which
    // is what makes an image visible without the scroll animation.
    for (var a = 0; a < items.length; a++) { items[a].removeAttribute('data-aos'); items[a].classList.add('aos-animate'); }
    var imgs = wrapper.querySelectorAll('img[loading="lazy"]');
    for (var j = 0; j < imgs.length; j++) imgs[j].loading = 'eager';

    // A row that fits on one desktop line (the tab cap, e.g. 4) is a fixed
    // row on every screen; on phones the same row shows half as many cards
    // (nv-row-capped in nividas-tokens.css: 4 → 2), like the 2-up grid.
    // Only a longer row becomes a carousel.
    // data-nv-show-more (Find your frame): never a carousel. A longer row
    // shows one line (4 / 2 on phones) and a "Show all" link that opens
    // the rest as more lines, so every row on the page behaves the same.
    // No carousels by default (layout rule 6): a row longer than one line
    // gets "Show all". A section can still ask for a carousel with
    // data-nv-carousel.
    var showMore = wrapper.getAttribute('data-nv-show-more') || (wrapper.hasAttribute('data-nv-carousel') ? null : 'frames');
    if (items.length <= perRow || showMore) {
      panel.setAttribute('data-nv-row-ready', '1');
      wrapper.classList.add('nv-flickity-ready');
      if (items.length > 0) {
        // data-nv-keep-cols: fewer cards keep the full row's card size
        // instead of stretching to fill it
        var cols = items.length;
        if (wrapper.hasAttribute('data-nv-keep-cols') || showMore) cols = perRow;
        wrapper.style.setProperty('--nv-static-cols', cols);
        wrapper.classList.add('nv-auto-fit', 'nv-row-capped');
        if (showMore && items.length > 2) addShowMore(wrapper, items.length, showMore, perRow);
      }
      return;
    }

    var Flkty = getFlickity();
    if (!Flkty) {
      tries = tries || 0;
      if (tries < 10) { setTimeout(function () { startPanel(panel, tries + 1); }, 200); }
      else { panel.setAttribute('data-nv-row-ready', '1'); wrapper.classList.add('nv-flickity-ready'); }
      return;
    }

    panel.setAttribute('data-nv-row-ready', '1');
    wrapper.classList.add('nv-flickity-active');
    try {
      var flkty = new Flkty(grid, {
        cellSelector: '.grid__item.grid-product',
        wrapAround: true,
        contain: false,
        cellAlign: 'center',
        percentPosition: false,
        pageDots: false,
        prevNextButtons: true,
        draggable: true,
        friction: 0.6,
        selectedAttraction: 0.08,
        dragThreshold: 5,
        setGallerySize: true,
        adaptiveHeight: false,
        resize: true
      });
      flkty.on('staticClick', function (event, pointer, cellElement) {
        if (window._nvTouchScrolled) return;
        if (!cellElement || event.target.closest('.nv-quick-add')) return;
        var link = cellElement.querySelector('.grid-product__link');
        if (link) window.location.href = link.href;
      });
      panel._nvFlkty = flkty;
    } catch (e) {
      wrapper.classList.remove('nv-flickity-active');
      wrapper.classList.add('nv-flickity-ready');
    }
  }

  // "Show all 15 frames" / "Show fewer" under a show-more row. Shown on
  // desktop only when there are more cards than one line holds (perRow);
  // on phones a line is 2 cards (nividas-tokens.css hides the link there
  // via .nv-row-more--fits-desktop when 3 or 4 cards fit on desktop).
  function addShowMore(wrapper, total, noun, perRow) {
    wrapper.classList.add('nv-row-more');
    if (total <= perRow) wrapper.classList.add('nv-row-more--fits-desktop');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nividas-link nividas-row__more';
    btn.setAttribute('aria-expanded', 'false');
    var more = 'Show all ' + total + ' ' + noun, fewer = 'Show fewer';
    btn.textContent = more;
    btn.addEventListener('click', function () {
      var open = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? fewer : more;
      if (!open && wrapper.getBoundingClientRect().top < 0) wrapper.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    var holder = document.createElement('div');
    holder.className = 'nividas-row__more-wrap';
    holder.appendChild(btn);
    wrapper.parentNode.insertBefore(holder, wrapper.nextSibling);
  }

  function select(row, tab, focus) {
    var tabs = row.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) tabs[i].removeAttribute('tabindex'); else tabs[i].setAttribute('tabindex', '-1');
      var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
      if (panel) { if (on) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', ''); }
    }
    if (focus) tab.focus();
    var shown = document.getElementById(tab.getAttribute('aria-controls'));
    startPanel(shown);
    if (shown && shown._nvFlkty) shown._nvFlkty.resize();
    // Keep the chosen tab in view when the tab row scrolls sideways (mobile)
    if (tab.scrollIntoView) {
      try { tab.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
    }
  }

  function init(row) {
    if (row.getAttribute('data-nv-row-bound') === '1') return;
    row.setAttribute('data-nv-row-bound', '1');
    var list = row.querySelector('[role="tablist"]');
    if (list) {
      list.addEventListener('click', function (e) {
        var tab = e.target.closest('[role="tab"]');
        if (tab) select(row, tab, false);
      });
      list.addEventListener('keydown', function (e) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(row, next, true); }
      });
    }
    var panels = row.querySelectorAll('.nividas-row__panel');
    for (var p = 0; p < panels.length; p++) startPanel(panels[p]);
  }

  function initAll() {
    var rows = document.querySelectorAll('[data-nividas-row]');
    for (var i = 0; i < rows.length; i++) init(rows[i]);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var panels = document.querySelectorAll('[data-nividas-row] .nividas-row__panel');
      for (var i = 0; i < panels.length; i++) if (panels[i]._nvFlkty) panels[i]._nvFlkty.resize();
    }, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initAll, 200); });
  } else {
    setTimeout(initAll, 200);
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 200); });
})();
